import Vue from 'vue'
import Modals from './components/Modals'
import ModalManager from './core/modal-manager'

require('./bootstrap')

window.Vue = Vue

Vue.prototype.$eventHub = new Vue()
Vue.use(ModalManager)

/**
 * TOP画面
 */
const page = new Vue({
    /**
     * target Element
     */
    el: '#content',
    /**
     * register components
     */
    components: {
        'modals': Modals
    },
    /**
     * function data
     */
    data() {
        return {
            model: {
            },
            isLoading: false
        }
    },
    /**
     * life cycle mounted
     */
    mounted() {
        this.showModal()
    },
    methods: {
        showModal() {
            let modalType = this.getModalType()
            switch (modalType) {
                case 'sendMail':
                    this.$modalManager.showSendMail()
                    break
                case 'delete':
                    this.$modalManager.showDeleteComplete()
                    break
                case 'phone':
                    this.$modalManager.showChangePhone()
                    break
                default:
                    break
            }
        },
        getModalType() {
            let query = window.location.search
            if (query.endsWith('ubm1')) {
                return 'sendMail'
            }
            if (query.endsWith('v5v4')) {
                return 'delete'
            }
            if (query.endsWith('ibe2')) {
                return 'phone'
            }
        },
        login() {
            this.isLoading = true
            this.$modalManager.showLoading()
            window.location.href = '/login'
        },
        signup() {
            this.isLoading = true
            this.$modalManager.showLoading()
            window.location.href = '/signup'
        }
    }
})
